// Shamelessly taken from https://www.npmjs.com/package/xhr-intercept
const XMLHttpRequestSend = XMLHttpRequest.prototype.send;
let reqCallbacks = [];
let resCallbacks = [];
let _init = false;
export const isInitialized = () => _init;
export const addRequestCallback = (callback) => reqCallbacks.push(callback);
export const addResponseCallback = (callback) => resCallbacks.push(callback);
export const removeRequestCallback = (callback) => {
    reqCallbacks = reqCallbacks.filter(item => item !== callback);
};
export const removeResponseCallback = (callback) => {
    resCallbacks = resCallbacks.filter(item => item !== callback);
};
export function startInterceptorService() {
    if (_init) {
        throw new Error('Entity Manager interceptor already started');
    }
    XMLHttpRequest.prototype.send = function (data) {
        const reqCallbacksRes = reqCallbacks.map(callback => callback(this, data));
        this.addEventListener('readystatechange', () => {
            if (this.readyState === 4) {
                resCallbacks.forEach(callback => callback(this));
            }
        });
        if (reqCallbacksRes.indexOf(false) === -1) {
            XMLHttpRequestSend.apply(this, [data]);
        }
    };
    _init = true;
}
export function stopInterceptorService() {
    if (!_init) {
        throw new Error('Entity Manager interceptor not currently started');
    }
    XMLHttpRequest.prototype.send = XMLHttpRequestSend;
    _init = false;
}
